import useLocalStorage from './useLocalStorage';

export const ENTRY_INSPECTOR_STORAGE_KEY = 'cmsEntryInspector';

/**
 * Whether the CMS "Edit" buttons are shown in preview. On by default; switched from the Dev Toolkit.
 * Every caller shares the value, so the toolkit switch applies without a reload.
 * @returns {[boolean, (enabled: boolean) => void]}
 */
const useEntryInspectorToggle = () => useLocalStorage<boolean>(ENTRY_INSPECTOR_STORAGE_KEY, true);

export default useEntryInspectorToggle;
